export const billing = {
  subscriptionSettings: "Subscription settings",
  taxRates: "Tax rates",
  numberRanges: "Number ranges",
  invoiceTemplate: "Invoice template"
};
